import {APP_INITIALIZER, Provider} from '@angular/core';
import {environment} from '../../../../../../environments/environment';
import {ACCOUNT_FORMATTING_PORT} from "../../../../../shared/domain/tokens/account-formatting.token";
import {DOMAIN_SUBSCRIBERS} from "../../../booking/domain/tokens/booking.tokens";
import {AccountFactoryService} from "../../account-factory.service";
import {AccountCacheService} from '../../application/services/account-cache.service';
import {AccountSelectorService} from '../../application/services/account-selector.service';
import {AccountStoreService} from '../../application/services/account-store.service';
import {AccountSyncService} from '../../application/services/account-sync.service';
import {ActivateAccountSubscriber} from "../../application/subscribers/activate-account.subscriber";
import {CreateAccountSubscriber} from "../../application/subscribers/create-account.subscriber";
import {RemoveAllEntriesSubscriber} from '../../application/subscribers/remove-all-entries.subscriber';
import {CreateAccountUseCase} from '../../application/use-cases/create-account.usecase';
import {ACCOUNT_API_REPOSITORY} from '../../domain/tokens/account-api.token';
import {ACCOUNT_SESSION_REPOSITORY} from '../../domain/tokens/account-session.token';
import {ACCOUNT_STORAGE_REPOSITORY} from '../../domain/tokens/account-storage.token';
import {ACCOUNT_STORE} from '../../domain/tokens/account-store.token';
import {AccountApiMockAdapter} from '../adapters/account-api-mock.adapter';
import {AccountApiAdapter} from '../adapters/account-api.adapter';
import {AccountSessionAdapter} from '../adapters/account-session.adapter';
import {AccountStorageAdapter} from '../adapters/account-storage.adapter';
import {AccountFormattingService} from "../services/account-formatting.service";
import {DeactivateAccountSubscriber} from "../../application/subscribers/deactivate-account.subscriber";
import {EntriesChangedSubscriber} from "../../application/subscribers/entries-changed.subscriber";
import {EntriesAppliedSubscriber} from "../../application/subscribers/entries-applied.subscriber";
import {AccountModeSubscriber} from "../../application/subscribers/account-mode.subscriber";
import {AccountPaymentSubscriber} from "@core/entities/account/application/subscribers/account-payment.subscriber";

export const ACCOUNT_REPOSITORY_PROVIDERS: Provider[] = [
  {
    provide: ACCOUNT_API_REPOSITORY,
    useClass: environment.mocksData.accounts
      ? AccountApiMockAdapter
      : AccountApiAdapter,
  },
  {
    provide: ACCOUNT_STORAGE_REPOSITORY,
    useClass: AccountStorageAdapter,
  },
  {
    provide: ACCOUNT_SESSION_REPOSITORY,
    useClass: AccountSessionAdapter,
  },
];

export const ACCOUNT_PORT_PROVIDERS: Provider[] = [
  {
    provide: ACCOUNT_STORE,
    useExisting: AccountStoreService,
  },
  {
    provide: ACCOUNT_FORMATTING_PORT,
    useClass: AccountFormattingService,
  }
];

export const ACCOUNT_USECASE_PROVIDERS: Provider[] = [CreateAccountUseCase];

export const ACCOUNT_SERVICE_PROVIDERS: Provider[] = [
  AccountCacheService,
  AccountSyncService,
  AccountSelectorService,
  AccountStoreService,
  AccountFactoryService,
];

export const ACCOUNT_SUBSCRIBER_PROVIDERS: Provider[] = [
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: EntriesChangedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: EntriesAppliedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: CreateAccountSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: RemoveAllEntriesSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: DeactivateAccountSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ActivateAccountSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: AccountModeSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: AccountPaymentSubscriber,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (subscribers: unknown[]) => () => {
      void subscribers;
    },
    deps: [DOMAIN_SUBSCRIBERS]
  }
];

export const ACCOUNT_PROVIDERS: Provider[] = [
  ...ACCOUNT_REPOSITORY_PROVIDERS,
  ...ACCOUNT_SERVICE_PROVIDERS,
  ...ACCOUNT_PORT_PROVIDERS,
  ...ACCOUNT_USECASE_PROVIDERS,
  ...ACCOUNT_SUBSCRIBER_PROVIDERS,
];
